import { render, staticRenderFns } from "./glossario.vue?vue&type=template&id=339d23b7&"
import script from "./glossario.vue?vue&type=script&lang=ts&"
export * from "./glossario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports